import { render, staticRenderFns } from "./TeamRequestsManagerPage.vue?vue&type=template&id=56b30b90"
import script from "./TeamRequestsManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b30b90')) {
      api.createRecord('56b30b90', component.options)
    } else {
      api.reload('56b30b90', component.options)
    }
    module.hot.accept("./TeamRequestsManagerPage.vue?vue&type=template&id=56b30b90", function () {
      api.rerender('56b30b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/manager/team-requests/TeamRequestsManagerPage.vue"
export default component.exports